/* ===== ICONS FOR COMMON ACTIONS =========================================== */

import { icons as zIcons } from '@juit/vue-z'

/** Our icon library, shared for consistency across the app */

export const icons = {
  /** Common actions */
  save: 'sym_r_check',
  upload: 'sym_r_upload',

  /** Label */
  label: 'sym_r_receipt_long',

  /** Dark mode */
  dark: {
    on: 'sym_r_dark_mode',
    off: 'sym_r_light_mode',
  },

  /** Navigation items */
  users: 'sym_r_person',
  report: 'sym_r_content_paste_search',

  // Zicons are LAST so that duplicates are highlighted
  ...zIcons,
} as const
